import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RouterConstants from '@app/constants/router';

const PrivateRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={
      props => (isLoggedIn
        ? <Component {...props} />
        : <Redirect to={{ pathname: RouterConstants.SIGN_IN }} />)
    }
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ user: { isLoggedIn } }) => ({
  isLoggedIn,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
